// import Vue from 'vue'
// import Router from 'vue-router'
// import { constantRouterMap } from '@/config/router.config'

// Vue.use(Router)

// export default new Router({
//     mode: 'history',
//     base: process.env.BASE_URL,
//     scrollBehavior: () => ({ y: 0 }),
//     routes: constantRouterMap
// })
// hash
// history
// 去除权限控制
import Vue from 'vue'
import Router from 'vue-router'
import { constantRouterMap, asyncRouterMap } from '@/config/router.config'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap.concat(asyncRouterMap)
})
